// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"styles_modalBody__240xw"};